<template>
  <section style="margin-bottom:60px;">
      <div class="container">
        <div class="row">
          
          <el-table style="width: 150%;"
                  :data="tableData"
                  v-loading.body="tableLoading"
                  element-loading-text="加载中..."
                  stripe border fit highlight-current-row>
            <el-table-column prop="a" label="时间" width="160" align="center"></el-table-column>
            <el-table-column prop="s" label="发布人" align="center"></el-table-column>
            <el-table-column prop="d" label="姓名" align="center"></el-table-column>
            <el-table-column prop="f" label="联系电话" align="center"></el-table-column>
            <el-table-column prop="g" label="发布类别" align="center"></el-table-column>
            <el-table-column prop="h" label="发布内容" align="left"></el-table-column>
            <el-table-column prop="j" label="处理时间" width="160" align="center"></el-table-column>
            <el-table-column prop="k" label="处理结果" align="left"></el-table-column>
            <el-table-column prop="l" label="反馈" align="center"></el-table-column>
          </el-table>
          <table style="width: 100%;margin-top: 15px;">
            <tr>
              <td align="right" width="80%">
                <el-pagination align="right" background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="tablePage.current"
                  :page-sizes="pageSizes"
                  :page-size="tablePage.size"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="tablePage.total">
                </el-pagination>
              </td>
            </tr>
          </table>
          <div style="margin-bottom:15px;margin-top: 15px;" class="info" >
            投诉处理满意率：97.3%
          </div>
        </div>
      </div>
    </section>
</template>
<script>
export default {

  data() {
    return {
      tableLoading: false,
      tableData: [],
      pageSizes:[10,20,50],
      tablePage: {
        current: null,
        pages: null,
        size: null,
        total: null
      },
      
    }
  },
  created(){

  },
  mounted(){
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.tableData=[
        {"a":"2021/3/20 14:24","s":"货主","d":"韩**","f":"151****3997","g":"咨询","h":"注册后是否可以马上发布货源？",
        "j":"2021/3/20 14:54","k":"货主您好，货主在平台上发布货源前，需要事先完成注册及认证工作，我会马上电话协助您完成，谢谢您！","l":"满意"},
        {"a":"2021/3/19 13:24","s":"司机","d":"李**","f":"150****7117","g":"咨询","h":"注册平台司机都需要什么证件？",
        "j":"2021/3/19 13:43","k":"司机您好，我会马上电话协助您完成，谢谢您！","l":"非常满意"},
        {"a":"2021/2/28 15:24","s":"司机","d":"曲**","f":"151****1226","g":"咨询","h":"平台的货源显示的路线收费都包括什么？",
        "j":"2021/2/28 17:54","k":"司机您好，我会马上电话协助您完成，谢谢您！","l":"非常满意"},
        {"a":"2021/2/28 10:24","s":"司机","d":"赵**","f":"151****1631","g":"咨询","h":"咱们平台有没有手机APP？",
        "j":"2021/2/28 15:45","k":"司机您好，我会马上电话协助您完成，谢谢您！","l":"--"},
        {"a":"2021/2/27 12:21","s":"司机","d":"张**","f":"151****7020","g":"咨询","h":"为什么需要我对司机进行评价？",
        "j":"2021/2/27 12:32","k":"司机您好，我会马上电话协助您完成，谢谢您！","l":"非常满意"},
        {"a":"2021/2/27 14:24","s":"司机","d":"董**","f":"133****9825","g":"咨询","h":"注册平台司机都需要什么证件？",
        "j":"2021/2/27 14:42","k":"司机您好，我会马上电话协助您完成，谢谢您！","l":"一般"},
        {"a":"2021/2/24 13:44","s":"货主","d":"赵**","f":"138****2493","g":"咨询","h":"我朋友没有智能手机，也可以使用平台的服务吗？",
        "j":"2021/2/24 13:59","k":"货主您好，我会马上电话协助您完成，谢谢您！","l":"满意"},
        {"a":"2021/2/23 12:26","s":"司机","d":"刘**","f":"147****5588","g":"咨询","h":"咱们平台有没有手机APP？",
        "j":"2021/2/23 12:51","k":"司机您好，我会马上电话协助您完成，谢谢您！","l":"非常满意"},
        {"a":"2021/2/22 11:23","s":"司机","d":"张**","f":"152****1859","g":"咨询","h":"如何申请发票？",
        "j":"2021/2/22 14:45","k":"司机您好，我会马上电话协助您完成，谢谢您！","l":"非常满意"},
        {"a":"2021/2/21 9:24","s":"货主","d":"窦**","f":"186****6528","g":"咨询","h":"注册后是否可以马上发布货源",
        "j":"2021/2/21 9:41","k":"货主您好，货主在平台上发布货源前，需要事先完成注册及认证工作，我会马上电话协助您完成，谢谢您！","l":"非常满意"}
      ]
      this.tablePage.current=1
      this.tablePage.pages=1
      this.tablePage.size=10
      this.tablePage.total=10

    },
    handleSizeChange(val) {
      this.tablePage.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.tablePage.current = val
      this.fetchData()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    }

  }
}
</script>
<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/swapperList.vue